// extracted by mini-css-extract-plugin
module.exports = {"cont":"_93444fe79c--cont--1Ddh2","controls":"_93444fe79c--controls--3I61d","gallery-arrow":"_93444fe79c--gallery-arrow--2649B"};